module.exports = __webpack_public_path__ + "static/media/fond-nuages-600.18d60e9a.png";